module.exports = __webpack_public_path__ + "media/images/borne de recharge pour véhicule électrique-df8efd7adfedc48693795fd912c357ad.svg";